import React from 'react';
import './OverallDayClosing.css';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api } from '../../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../Layout';


const OverallDayClosing = () => {
  const history = useHistory();
  const [show, setShow]  = useState(false);
  const [tableData, setTableData] = useState([]);
  const [orderListData, setOrderListData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statsData, setStatsData] = useState([]); // Placeholder for any stats data
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedShopId, setSelectedShopId] = useState(null); // Selected shopId for API call


 
const sampleData = [
  { sNo: 1, customerName: "JP", mobile: "9876543210", orderId: "123", orderAddress: "123, ABC, Trichy", orderType: "Normal Order", slotType: "Single slot", slotName: "Slot-1", deliveryDate: "07-11-2024", amount: 250, status: "Rejected" },
  { sNo: 2, customerName: "Alice", mobile: "9123456780", orderId: "124", orderAddress: "456, DEF, Chennai", orderType: "Express Order", slotType: "Single slot", slotName: "Slot-2", deliveryDate: "08-11-2024", amount: 500, status: "Accepted" },
  { sNo: 3, customerName: "Bob", mobile: "9345678901", orderId: "125", orderAddress: "789, GHI, Madurai", orderType: "Normal Order", slotType: "Multiple slot", slotName: "Slot-3", deliveryDate: "09-11-2024", amount: 350, status: "New" },
  { sNo: 4, customerName: "Cathy", mobile: "9456789012", orderId: "126", orderAddress: "101, JKL, Coimbatore", orderType: "Normal Order", slotType: "Single slot", slotName: "Slot-4", deliveryDate: "10-11-2024", amount: 420, status: "Rejected" },
  { sNo: 5, customerName: "David", mobile: "9567890123", orderId: "127", orderAddress: "202, MNO, Salem", orderType: "Express Order", slotType: "Multiple slot", slotName: "Slot-5", deliveryDate: "11-11-2024", amount: 275, status: "Rejected" },
 
];

useEffect(() => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const year = today.getFullYear();
  const defaultDate = `${day}-${month}-${year}`;
  setSelectedDate(defaultDate);

  fetchTableData(defaultDate);
}, []);

// Fetch table data based on the selected date
const fetchTableData = async (currentDate) => {
  setLoading(true);
  try {
    const token = localStorage.getItem('SAtoken');
    const response = await axios.get(`${var_api}day-closing-summary/${currentDate}`, {
      headers: {
        Authorization: `${token}`,
      },
    });

    setLoading(false);
    const data = response.data.data || [];

    // Process and set table data
    const formattedTableData = data.map((item, index) => ({
      sNo: index + 1,
      shopName: item.shop_name || 'N/A',
      sales: parseFloat(item.total_sales) || 0,
      orders: parseInt(item.total_orders, 10) || 0,
      expense: parseFloat(item.total_expense) || 0,
      profit: parseFloat(item.total_profit) || 0,
      shopid: item.shop_id,
    }));
    setTableData(formattedTableData);
    console.log(formattedTableData);

    // Calculate totals
    const totalSales = data.reduce((acc, item) => acc + (parseFloat(item.total_sales) || 0), 0);
    const totalOrders = data.reduce((acc, item) => acc + (parseInt(item.total_orders, 10) || 0), 0);
    const totalExpense = data.reduce((acc, item) => acc + (parseFloat(item.total_expense) || 0), 0);
    const totalProfit = data.reduce((acc, item) => acc + (parseFloat(item.total_profit) || 0), 0);
    const totalShops = response.data.total_shops || 0;

    setStatsData([
      { key: 'Total Shops', value: totalShops },
      { key: 'Overall Total Sales', value: totalSales },
      { key: 'Total Order', value: totalOrders },
      { key: 'Total Expense', value: totalExpense },
      { key: 'Total Net Profit', value: totalProfit },
    ]);
  } catch (error) {
    setLoading(false);
    console.error('Error fetching data:', error);
    setTableData([]);
  }
};

const fetchOrderListData = async (shopId, currentDate) => {
  setLoading(true);
  try {
    const token = localStorage.getItem('SAtoken');
    const response = await axios.get(`${var_api}particular-shop-dayclosing/${shopId}/${currentDate}`, {
      headers: {
        Authorization: `${token}`,
      },
    });

    setLoading(false);
    const data = response.data.data || [];
    setOrderListData(data);

  } catch (error) {
    setLoading(false);
    console.error('Error fetching data:', error);
    setOrderListData([]);
  }
};
const handleDateChange = (e) => {
  const newDate = e.target.value;
  
  // Convert the date to dd-mm-yyyy format
  const dateParts = newDate.split('-'); // The input value is in yyyy-mm-dd format
  const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`; // Reversing to dd-mm-yyyy
  
  setSelectedDate(formattedDate); // Set the formatted date
  fetchTableData(formattedDate); // Fetch data when the date is changed
  fetchOrderListData(formattedDate);
};


// Get today's date in yyyy-mm-dd format for the input field
const getCurrentDateInputValue = () => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const year = today.getFullYear();
  return `${day}-${month}-${year}`;
};

const handleViewClick = (shopId, currentDate) => {
  console.log('Shop ID:', shopId, 'Date:', currentDate);
  setSelectedShopId(shopId); // Set the selected shopId
  fetchOrderListData(shopId,currentDate); // Fetch the order list data for the selected shop and date
  setShow(true); // Open the modal
};
    
      const handleSearchInput = (e) => {
        setSearchTerm(e.target.value);
      };
    
      const filteredData = tableData.filter((item) =>
        item.shopName.toLowerCase().includes(searchTerm.toLowerCase())
      );

      const filteredDataModel = orderListData.filter((data) =>
        data.customer_name.toLowerCase().includes(searchTerm) || 
        data.order_no.toLowerCase().includes(searchTerm)
      );
    

    //Go to home page
    const handleButtonClick = () => {
      history.push('/AdminHome')
    }


    return(
      <>         
      <Layout>
        <div class="splitpo">
          <div style={{border:"none", padding:"15px", width:"100%", height:"630px",margin:"auto",borderRadius:"15px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px", marginTop:"-15px"}}>
      <div>
      <h4 className='ushesaodc'>OVERALL DAY CLOSING</h4>
      <div className="d-flex justify-content-end gap-3">
        <div>
        <input
        type="date"
        className="form-control form-control-sm"
        id="fromDate"
        name="fromDate"
        style={{ fontSize: '15px', borderRadius: '10px' }}
        value={selectedDate.split('-').reverse().join('-')} // Format date as dd-mm-yyyy for display
        onChange={handleDateChange}
        max={getCurrentDateInputValue()}
      />
      </div>

{/* Search */}
<div style={{ maxWidth: "200px" }}>
    {/* <label htmlFor="search" className="form-label" style={{ fontSize: "14px" }}>
        Search
    </label> */}
    <input
              type="search"
              className="form-control form-control-sm"
              id="search"
              placeholder="Search"
              onChange={handleSearchInput}
              style={{ fontSize: '15px', borderRadius: '10px' }}
            />
</div>

</div>

{/* <div className="stats-containers-flex mb-2 mt-2">
  {statsData.map((stat, index) => (
    <div 
      key={index} 
      className={`stat-columns-flex ${index !== statsData.length - 1 ? 'with-dividers ' : ''}`}
    >
      <div className="stat-columns">
        <h4>{stat.key.charAt(0).toUpperCase() + stat.key.slice(1)}</h4>
        <h2>{stat.key === "sales" ? `$${stat.value.toLocaleString()}` : stat.value}</h2>
      </div>
    </div>
  ))}
</div> */}
<div className="stats-containers-flex mb-2 mt-2">
        {statsData.map((stat, index) => (
          <div
            key={index}
            className={`stat-columns-flex ${index !== statsData.length - 1 ? "with-dividers" : ""}`}
          >
            <div className="stat-columns">
              <h4>{stat.key.charAt(0).toUpperCase() + stat.key.slice(1)}</h4>
              <h2>
                {typeof stat.value === "number"
                  ? `$${stat.value.toLocaleString()}`
                  : stat.value}
              </h2>
            </div>
          </div>
        ))}
      </div>

      <div className="table-container" style={{ height:"500px", overflowX: 'auto', overflowY: 'scroll', marginTop:"10px" }}>
      <table className="table table-hover small-first-col" style={{ border: 'none', borderColor: 'grey', width: '95%', margin: 'auto' }}>
            <thead>
              <tr style={{ fontWeight: 'bolder' }}>
                <th style={{ textTransform: 'capitalize', textAlign: 'left' }}>S.No</th>
                <th style={{ textTransform: 'capitalize', textAlign: 'left' }}>Shop Name</th>
                <th style={{ textTransform: 'capitalize', textAlign: 'left' }}>Sales</th>
                <th style={{ textTransform: 'capitalize', textAlign: 'left' }}>Orders</th>
                <th style={{ textTransform: 'capitalize', textAlign: 'left' }}>Expense</th>
                <th style={{ textTransform: 'capitalize', textAlign: 'left' }}>Profit</th>
                <th style={{ textTransform: 'capitalize', textAlign: 'left' }}>Action</th>
              </tr>
            </thead>
            {loading ? (
              <tbody>
                <tr>
                  <td colSpan="7" className="text-center">
                    Loading...
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody className="body-half-screen" style={{ fontSize: '14.5px' }}>
                {filteredData.map((data) => (
                  <tr key={data.sNo}>
                    <td>{data.sNo}</td>
                    <td>{data.shopName}</td>
                    <td>{data.sales}</td>
                    <td>{data.orders}</td>
                    <td>{data.expense}</td>
                    <td>{data.profit}</td>
                    <td>
                       <button className="btn btn-primary btn-sm" onClick={() => handleViewClick(data.shopid, selectedDate)}>View</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>

      </div>
</div>
        </div>
      
      </div>

      <Modal
        show={show}
        onHide={()=>setShow(false)}
        backdrop="static"
        keyboard={false}
        size="xl" // Set size to large
      >
        <Modal.Header closeButton >
          {/* <Modal.Title>confirmation</Modal.Title> */}
          ORDERS
        </Modal.Header>
        <Modal.Body>
        <div class="row">
         <div class="col">
         {/* <h4 className='ushe'>NEW ORDERS</h4> */}
         </div>
         <div class="col">
         <input class="form-control" type="Search" placeholder="Search" 
     style={{maxWidth:"230px",borderRadius:"10px",border:"1px solid black",float:"right"}}  onChange={handleSearchInput}/>
         </div>
        
       </div>
      <div className="table-container" style={{ minHeight:"520px", overflowX: 'auto', overflowY: 'scroll', marginTop:"5px" }}>
      <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"95%",margin:"auto"}}>
  <thead>
    <tr style={{fontWeight:"bolder"}}>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Customer name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Mobile</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Order Id</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Order Address</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Order Type</th>
      {/* <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Slot Type</th> */}
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Slot Name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Delivery Date</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Amount</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Status</th>
    </tr>
  </thead>
  {loading ? (
        <div className="loader-containeru">
      	  <div className="spinneru"></div>
        </div>
  ) : 
  <tbody style={{ fontSize: "14.5px" }}>
  {filteredDataModel.map((data, index) => (
                  <tr key={data.id}>
                    <td>{index + 1}</td>
                    <td>{data.customer_name}</td>
                    <td>{data.mobile_no}</td>
                    <td>{data.order_no}</td>
                    <td>{data.delivery_address}</td>
                    <td style={{ color: "blue", fontWeight: "bold" }}>
                      {data.order_type == 1 ? "Normal Order" : data.order_type === 2 ? "Credit Order"  : "Pending"}
                    </td>
                    {/* <td>{data.slot_type == 1 ? "Type 1" : "Type 2"}</td> */}
                    <td>{data.slot_name}</td>
                    <td>{data.booking_date}</td>
                    <td>{data.amount}</td>
                    <td
                      style={{
                        color: data.order_status === 0 ? "blue" :
                        data.order_status === 1 ? "orange" :
                        data.order_status === 2 ? "green" :
                        data.order_status === 3 ? "red" : "gray",
                        fontWeight: "bold",
                      }}
                    >
                       {data.order_status === 0 ? "New" :
           data.order_status === 1 ? "Partial" :
           data.order_status === 2 ? "Delivered" :
           data.order_status === 4 ? "Cancelled" : "Cancelled"}
                    </td>
                  </tr>
                ))}
</tbody>
}
</table>


      </div>
          </Modal.Body>
          </Modal>
       </Layout></>

        
    )
}

export default OverallDayClosing;